const boilerplate04 = `# Footnotes

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eget turpis nec justo volutpat efficitur. Sed ac sapien in magna faucibus faucibus eu sed nisl. Aenean non tristique odio, eu condimentum nisl. Suspendisse porttitor ante id lectus pharetra, id pretium odio lacinia. Vestibulum auctor volutpat pharetra. Nam rhoncus dapibus enim eget ornare.[^1] Phasellus convallis nisi a efficitur iaculis.[^2] Etiam tempus massa diam, sit amet lacinia metus suscipit sit amet. Nunc consequat ligula ac auctor mollis. Integer accumsan ornare neque, id dapibus elit. Ut accumsan lacinia metus nec luctus.[^3]


[^1]: Here is the footnote.

[^2]: Here is the second footnote.

[^3]: Here's one with multiple blocks.

    Subsequent paragraphs are indented to show that they
belong to the previous footnote.



`;
export { boilerplate04 };



// WEBPACK FOOTER //
// ./src/boilerplates/boilerplate04.js